module.exports = __webpack_public_path__ + "335c132fffd39d9768986ac4bdd9eb8a.pdf";